import { createContext, useContext, useEffect, useState } from "react";
import { api, tokenStore } from "./api";
import { logger } from "./logger";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  // user: null = checking, false = unauthenticated, object = authenticated
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        if (!cancelled) setUser(data);
      } catch (err) {
        if (!cancelled) setUser(false);
        if (err?.response?.status !== 401) {
          logger.error("auth/me failed:", err);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
    // Run once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    // Server sets httpOnly cookies AND returns access_token in body.
    // We persist the token to localStorage so the Authorization: Bearer header
    // works even on cross-origin / custom-domain deployments.
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.access_token) {
      tokenStore.set(data.access_token);
    }
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      logger.error("logout failed:", err);
    }
    tokenStore.clear();
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, loading, login, logout, setUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
